import { useField } from 'formik';
import { Textarea, TextareaProps } from '@antimatterhq/ui/components/textarea';

export const FormTextarea = ({ name = '', ...props }: TextareaProps) => {
  const [field, meta] = useField(name);
  const hasError = meta.touched && !!meta.error && !!name;
  const variant = hasError ? 'error' : 'default';
  // eslint-disable-next-line
  props = { ...field, ...props };
  return (
    <Textarea
      name={name}
      variant={variant}
      data-testid={`form-textarea-${name}`}
      {...props}
    />
  );
};
